import React from 'react'
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/home/logo.gif';

const LogoCom = () => {
    const navigate = useNavigate();

    return (
        <div className='logo-sect showing-cursor'>
            <img onClick={() => navigate(`/`)} src={logo} alt="Logo" />
        </div>
    )
}

export default LogoCom
